function Background(color,border) {

    this.name = 'background';
    this.color = color;
    this.border=border;
}

export {Background};
